'use client';

import { c as _c } from "react/compiler-runtime";
import { NormalizedCacheObject, createHttpLink, useApolloClient } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { ApolloClient, ApolloNextAppProvider, InMemoryCache } from '@apollo/client-integration-nextjs';
import { PropsWithChildren, ReactNode } from 'react';
import { cache } from '../../libs/apollo/cache';
import { User } from '../../libs/auth/authContext';
function UpdateAuth({
  token,
  children
}: {
  token?: string;
  children: ReactNode;
}) {
  const apolloClient = useApolloClient();
  if (token != null) {
    apolloClient.defaultContext.token = token;
  }
  return <>{children}</>;
}
const httpLink = createHttpLink({
  uri: process.env.NEXT_PUBLIC_GATEWAY_URL,
  headers: {
    'x-graphql-client-name': 'videos-admin',
    'x-graphql-client-version': process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ?? ''
  }
});
export function ApolloProvider(t0) {
  const $ = _c(4);
  const {
    children,
    user
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const authLink = setContext(_temp);
    t1 = function makeClient() {
      return new ApolloClient({
        cache: new InMemoryCache(cache),
        link: authLink.concat(httpLink),
        connectToDevTools: true
      });
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const makeClient = t1;
  const t2 = user?.token;
  let t3;
  if ($[1] !== children || $[2] !== t2) {
    t3 = <ApolloNextAppProvider makeClient={makeClient}><UpdateAuth token={t2}>{children}</UpdateAuth></ApolloNextAppProvider>;
    $[1] = children;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
async function _temp(_, t0) {
  const {
    headers,
    token
  } = t0;
  return {
    headers: {
      ...headers,
      Authorization: token != null ? `JWT ${token}` : undefined
    }
  };
}